import { generatePath, matchPath } from 'react-router-dom';
import type { Funnelable } from '../types';
import { Funnel } from '../types';

export class StudioLocations implements Funnelable {
  routeSegment = '/studio';

  funnels = [Funnel.Remixer];

  song = {
    pathname: (id: string, title: string, isAIGenerated?: boolean) =>
      generatePath(`${this.routeSegment}/${this.song.route}`, {
        songParams: `${isAIGenerated ? 'aisong-' : ''}${encodeURIComponent(
          title
        )}-${id}`,
      }),
    /**  Song params contains both the song name and the song id, seperated by a dash.  */
    route: `:songParams`,
  };

  project = {
    pathname: (projectId: string) =>
      generatePath(`${this.routeSegment}/${this.project.route}`, {
        projectId,
      }),
    route: `project/:projectId`,
  };

  funnelsForPathname(pathname: string) {
    if (matchPath(`${this.routeSegment}/*`, pathname)) return this.funnels;
    return null;
  }
}
